import type { DriverPenaltySeverity, DriverPenaltyStatus } from '@/backend/market'

export class DriverPenaltyEntity {
  id?: string
  driverId?: number
  driverFullName?: string | null
  driverAvatarImagePath?: string | null
  driverRegionId?: number
  type?: string | null
  severity?: DriverPenaltySeverity
  source?: string | null
  reason?: string | null
  status?: DriverPenaltyStatus
  detectedAt?: string | null
  reviewedByUserId?: string | null
  reviewedAt?: string | null
  effectiveFrom?: string | null
  effectiveTo?: string | null
  createdAt?: string
  updatedAt?: string
}
